// components/ImageGalleryModal.jsx
import React, { useState, useRef ,useEffect} from "react";
import { Dialog } from "@headlessui/react";
import {
  XMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";

const ImageGalleryModal = ({ isOpen, setIsOpen, images, currentIndex }) => {
  const [activeIndex, setActiveIndex] = useState(currentIndex || 0);
  const thumbnailRef = useRef(null);

  const scrollThumbnails = (direction) => {
    const container = thumbnailRef.current;
    if (!container) return;
    const scrollAmount = direction === "left" ? -200 : 200;
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  useEffect(() => {
    if (!isOpen) return;
  
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        (prevIndex + 1) % images.length
      );
    }, 5000);
  
    return () => clearInterval(interval); // Cleanup on unmount
  }, [isOpen, images.length]);
  
  // Optional: Reset timer on manual image click
  const handleSelect = (index) => {
    setActiveIndex(index);
  };

//   const handleSelect = (index) => setActiveIndex(index);

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="fixed inset-0 z-[1000] bg-black bg-opacity-90 flex items-center justify-center"
    >
      <div className="relative w-full max-w-6xl mx-auto px-4 pt-8 pb-4">
        {/* Close Button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 text-white z-20"
        >
          <XMarkIcon className="w-7 h-7" />
        </button>

        {/* Main Image */}
        <div className="w-[70vw] h-[70vh] bg-black rounded-xl overflow-hidden mx-auto">
          <img
            src={images[activeIndex]}
            alt="Main"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Thumbnails with scroll buttons */}
        <div className="relative mt-4">
          <button
            onClick={() => scrollThumbnails("left")}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white z-10 p-1 rounded-full hover:bg-opacity-80"
          >
            <ChevronLeftIcon className="h-6 w-6" />
          </button>
          <div
          ref={thumbnailRef}
          className="mx-8 flex gap-3 overflow-x-auto"
          style={{
            scrollBehavior: "smooth",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE 10+
          }}
          >
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`thumb-${idx}`}
                onClick={() => handleSelect(idx)}
                className={`h-16 w-28 object-cover rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                  activeIndex === idx
                    ? "border-white"
                    : "border-transparent opacity-70 hover:opacity-100"
                }`}
              />
            ))}
          </div>
          <button
            onClick={() => scrollThumbnails("right")}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white z-10 p-1 rounded-full hover:bg-opacity-80"
          >
            <ChevronRightIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ImageGalleryModal;
